class WooFilterBoxItem {
  constructor(obj) {
    this.obj = obj;
    this.init();
  }

  init() {
    this.obj.addEventListener("click", () => {
      this.onClick();
    });
  }

  onClick() {
    if (this.isChecked()) {
      this.uncheck();
    } else {
      this.check();
    }

    this.onChange(this);
  }

  onChange(_obj) {}

  isChecked() {
    return this.obj.classList.contains("checked");
  }

  uncheck() {
    this.obj.classList.remove("checked");
  }

  check() {
    this.obj.classList.add("checked");
  }

  getId() {
    return this.obj.getAttribute("data-id") || "";
  }

  getSlug() {
    return this.obj.getAttribute("data-slug") || "";
  }

  getName() {
    return this.obj.getAttribute("data-name") || "";
  }
}

export default class WooFilterBoxComponent {
  constructor(obj) {
    this.obj = obj;
    this.items = [];
    this.checked = [];
    this.slug = this.obj.getAttribute("data-slug") || "";
    this.findOptions();
  }

  getSlug() {
    return this.slug;
  }

  getChecked() {
    return this.checked;
  }

  setCheckedBySlugs(slugs) {
    if (!Array.isArray(slugs)) {
      return;
    }

    const slugSet = new Set(
      slugs
        .map((slug) => (typeof slug === "string" ? slug.trim() : ""))
        .filter((slug) => slug !== ""),
    );

    this.checked = [];

    for (let i = 0; i < this.items.length; i += 1) {
      const singleItem = this.items[i];
      const itemSlug = singleItem.getSlug();

      if (slugSet.has(itemSlug)) {
        singleItem.check();
        this.checked.push({
          slug: singleItem.getSlug(),
          id: singleItem.getId(),
          name: singleItem.getName(),
        });
      } else {
        singleItem.uncheck();
      }
    }
  }

  findOptions() {
    const items = this.obj.querySelectorAll(".ds-woo-filter__item");

    for (let i = 0; i < items.length; i += 1) {
      const singleItem = new WooFilterBoxItem(items[i]);
      singleItem.onChange = (item) => {
        this.handleItemChange(item);
      };

      this.items.push(singleItem);
    }
  }

  handleItemChange(item) {
    this.checked = [];

    for (let i = 0; i < this.items.length; i += 1) {
      const singleItem = this.items[i];
      if (!singleItem.isChecked()) {
        continue;
      }

      this.checked.push({
        slug: singleItem.getSlug(),
        id: singleItem.getId(),
        name: singleItem.getName(),
      });
    }

    this.onChange(item);
  }

  onChange(_item) {}
}
